<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px"><path d="m480-346.5-237-237 41.5-41L480-429l195.5-195.5 41.5 41-237 237Z"/></svg>
</template>